import React, { useContext, useMemo } from 'react';
import Context from './CalculatorSectorContext';
import { IdRoute } from '../../../../../../types';
import useServiceReducer from '../../../../../../shared/hooks/useServiceReducer';
import calculatorService from '../../../../../../services/calculatorService';
import calculatorSectorReducer from './CalculatorSectorReducer';
import MainContext from '../../../../../App/MainProvider/context';

const CalculatorSectorProvider: React.FC<IdRoute> = ({ id: operationId, children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [calculatorSectorContext, , , , , reload] = useServiceReducer(
    calculatorService.getCalculatorSectorContext,
    calculatorSectorReducer,
    operationId,
    [inSuperUserMode(), inGuidanceServiceMode()]
  );

  const value = useMemo(
    () =>
      calculatorSectorContext && {
        calculateId: calculatorSectorContext.calculateId,
        operationId: calculatorSectorContext.operationId,
        country: calculatorSectorContext.country,
        sector: calculatorSectorContext.sector,
        measurementSystem: calculatorSectorContext.measurementSystem,
        landUseChange: calculatorSectorContext.landUseChange,
        buildingConstruction: calculatorSectorContext.buildingConstruction,
        roadPavement: calculatorSectorContext.roadPavement,
        energyConsumptionConstruction: calculatorSectorContext.energyConsumptionConstruction,
        constructionEquipment: calculatorSectorContext.constructionEquipment,
        rawMaterialUse: calculatorSectorContext.rawMaterialUse,
        energyConsumptionOperation: calculatorSectorContext.energyConsumptionOperation,
        streetlights: calculatorSectorContext.streetlights,
        roadMaintenance: calculatorSectorContext.roadMaintenance,
        energyEfficiency: calculatorSectorContext.energyEfficiency,
        totalConstructionOverriden: calculatorSectorContext.totalConstructionOverriden,
        totalOperationOverriden: calculatorSectorContext.totalOperationOverriden,
        isFinished: calculatorSectorContext.isFinished,
        reload,
      },
    [calculatorSectorContext, reload]
  );

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default CalculatorSectorProvider;
